module.exports = __webpack_public_path__ + "static/img/login-title.081363e8.png";